import React from "react";
import logo from "../assets/SVG/Logo_new.svg";
import { ButtonComponent } from "@/components";
import logo_Bitramp from "../assets/SVG/logo_Bitramp.svg";
import { isBitramp } from "@/utils/utils";

const NotFound: React.FC = () => {
  return isBitramp() ? (
    <div className="h-screen bg-[#212121] dark:bg-gray-800 flex flex-col items-center justify-center">
      <img src={logo_Bitramp} alt="logo" />
      <p className="text-gray-500 dark:text-gray-200 mb-8 mt-4">404 Not Found</p>
      <ButtonComponent
        title={"Home"}
        actionCallback={() => {
          window.location.href = "/";
        }}
        name="button--classic !bg-[#ee33d9] !text-white"
      />
    </div>
  ) : (
    <div className="h-screen dark:bg-gray-800 flex flex-col items-center justify-center">
      <img src={logo} alt="logo" />
      <p className="text-gray-600 dark:text-gray-200 mb-8">404 Not Found</p>
      <ButtonComponent
        title={"Home"}
        actionCallback={() => {
          window.location.href = "/";
        }}
        name="button--classic"
      />
    </div>
  );
};

export default NotFound;
